import GalleryModal from '../components/galleryModal';
import AF from '../utlis/AF';

const CLASS_ACTIVE = 'is-gallery-loaded-more';

export default class Gallery {
    constructor(element) {
      this.el = element;
      this.galleryModal = GalleryModal.instance();
      this.af = AF.instance();
      this.tiles = [].slice.call(this.el.querySelectorAll('[gallery-tile]'));
      this.l = this.tiles.length;
        
      this.activate = this.activate.bind(this);
      this.onClick = this.onClick.bind(this);

      this._initialize();
    }

    _initialize() {
      // Attach click event listeners to all gallery tiles
      for (let i = 0; i <= this.l - 1; i++) {
        this.tiles[i].addEventListener('click', this.onClick.bind(this, i));
        this.galleryModal.createItem(i, this.tiles[i].getAttribute('gallery-tile'));
      }
    }

    _disconnect() {
      // Remove event listeners when disconnecting the gallery
      for (let i = this.l - 1; i >= 0; i--) {
        this.tiles[i].removeEventListener('click', this.onClick);
      }
    }

    onClick(index) {
      this.galleryModal.open(index);
    }

    activate() {
      this.af.onNextWrite(() => {
        this.el.classList.add(CLASS_ACTIVE);
      });
    }

    // Optionally call this when you want to "destroy" or "disconnect" the gallery
    destroy() {
      this._disconnect();
    }
}
